// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================= */
/* BASE LAYOUT */
/* ================================================= */

.final-step {
  max-width: 800px;
  margin: 15px auto;
  padding: 2px;
}

.final-step-header {
         font-size: 24px;
    margin-left: 22px;
}

.final-step-prequal {
  font-size: 16px;
  color: #555;
  margin-bottom: 20px;
  padding: 0 10px 0 22px;
}
.final-step-button {
  background-color: #4CAF50;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.ai-benefits {
  text-align: left;
  font-size: 15px;
  color: #555;
  margin-bottom: 10px;
  padding: 0 10px 0 12px;
  margin-top: 1px;
  margin-left: 11px;
}

h2 {
  text-align: left;
  font-size: 20px;
  margin: 10px 0;
}

p {
 
  font-size: 15px;
  margin: 10px 0;
}

/* ================================================= */
/* TEXT WRAPPING */
/* ================================================= */

.report-output,
.report-p,
.report-li {
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal;
}

/* ================================================= */
/* TYPOGRAPHY */
/* ================================================= */

.report-h2 {
  margin-top: 20px;
  font-size: 20px;
  font-weight: 700;
}

.report-h3 {
  margin-top: 16px;
  font-size: 16px;
  font-weight: 600;
}

.report-p {
  margin-bottom: 10px;
  line-height: 1.6;
}

.report-ul {
  margin: 8px 0 16px 18px;
  padding-left: 12px;
}

.report-li {
  margin-bottom: 6px;
}

/* ================================================= */
/* IMAGE GALLERY */
/* ================================================= */

.image-gallery {
  display: flex;
  gap: 12px;
  margin: 16px 0;
  flex-wrap: wrap;
}

.report-image {
  max-width: 180px;
  border-radius: 6px;
  object-fit: cover;
}

/* ================================================= */
/* REPORT PANEL */
/* ================================================= */

.report-panel {
  display: flex;
  flex-direction: column;
}

.report-output {
  padding: 15px;
  padding-top: 1px;
  background: #fafafa;
  border-radius: 8px;
}

/* ================================================= */
/* CARET ANIMATION */
/* ================================================= */

.caret {
  animation: blink 1s steps(1) infinite;
}

@keyframes blink {
  50% { opacity: 0; }
}

/* ================================================= */
/* IMAGE STRIP */
/* ================================================= */

.report-image-strip {
  display: flex;
  gap: 12px;
  margin: 24px auto 32px;
  width: 50%;
  justify-content: center;
  flex-wrap: wrap;
}

.report-image-strip img {
  max-width: calc(33.333% - 8px);
  height: auto;
  border-radius: 8px;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

html[data-brand="house-helper"] .featured-widget {
  border-color: rgba(124, 194, 67, 0.5);
}


/* ================================================= */
/* TWO COLUMN LAYOUT */
/* ================================================= */

/* -------- Desktop + Tablet -------- */
@media (min-width: 550px) {

  .featured-widget {
    background: #ffffff;
    border-radius: 16px;
    padding: 10px;
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
    border: 1px solid #3690ffa2;
    width: 200px;
  }

  .final-two-column {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    margin-top: 20px;
  }

  .final-left {
    flex: 0 0 74%;
    margin-left: 15px;
  }

  .final-right {
    flex: 0 0 20%;
  }

  .featured-widget {
    position: sticky;
    top: 120px;
  }
}

/* -------- Mobile Only -------- */
@media (max-width: 550px) {


  .final-two-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .final-left,
  .final-right {
    width: 100%;
  }

  .featured-widget {
     position: relative;
        top: auto;
        background: #ffffff;
        border-radius: 16px;
        padding: 7px;
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
        border: 1px solid #3690ffa2;
        /* width: 95%; */
        justify-content: center;
        display: grid;
        margin-left: 49px;
        margin-right: 64px;
  }

  html[data-brand="house-helper"] .featured-widget {
    border-color: rgba(124, 194, 67, 0.5);
  }

  h2 {
    text-align: center;
  }

  .report-output,
  .report-p,
  .report-li {
    max-width: 94%;
        margin-left: 10px;
  }
}

/* ================================================= */
/* RIGHT SIDE WIDGET */
/* ================================================= */



.featured-widget h3 {
  margin-top: 0;
  margin-bottom: 1px;
  font-size: 18px;
  font-weight: 600;
}

.featured-widget-pro {
  margin: 0px 0 10px;
    padding: 6px 8px;
    border: 1px solid rgba(54, 144, 255, 0.28);
    border-radius: 12px;
    background: #f7fbff;
}

.featured-widget-pro-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}

.featured-widget-pro-heading {
  display: flex;
  align-items: center;
  gap: 5px;
}

.featured-widget-pro-logo {
  width: 55px;
    height: 55px;
    flex: 0 0 auto;
    border-radius: 10px;
    border: 1px solid rgba(23, 50, 78, 0.08);
    object-fit: contain;
    background: #ffffff;
    padding: 2px;
}

.featured-widget-pro-label,
.featured-widget-pro-name {
  margin: 0;
}

.featured-widget-pro-label {
  color: #1d77bd;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
}

.featured-widget-pro-name {
  color: #17324e;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
}

.featured-widget-pro-link {
      color: #1d77bd;
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;
    justify-self: center;
    text-align: center;
    width: 100%;
    display: block;
}

.featured-widget-pro-link:hover {
  text-decoration: underline;
}

.widget-button {
      margin-bottom: 5px;
    background-color: #0d6efd;
    color: #ffffff;
    padding: 6px 11px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    width: 100%;
    font-weight: 600;
    font-size: 10pt !important;
}

.widget-button:hover {
  background-color: #0b5ed7;
}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/FinalStep.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD,gBAAgB;AAChB,sDAAsD;;AAEtD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;SACS,eAAe;IACpB,iBAAiB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA,sDAAsD;AACtD,kBAAkB;AAClB,sDAAsD;;AAEtD;;;EAGE,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD,eAAe;AACf,sDAAsD;;AAEtD;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD,kBAAkB;AAClB,sDAAsD;;AAEtD;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sDAAsD;AACtD,iBAAiB;AACjB,sDAAsD;;AAEtD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD,oBAAoB;AACpB,sDAAsD;;AAEtD;EACE,qCAAqC;AACvC;;AAEA;EACE,MAAM,UAAU,EAAE;AACpB;;AAEA,sDAAsD;AACtD,gBAAgB;AAChB,sDAAsD;;AAEtD;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;;AAGA,sDAAsD;AACtD,sBAAsB;AACtB,sDAAsD;;AAEtD,uCAAuC;AACvC;;EAEE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,2CAA2C;IAC3C,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA,kCAAkC;AAClC;;;EAGE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;KACG,kBAAkB;QACf,SAAS;QACT,mBAAmB;QACnB,mBAAmB;QACnB,YAAY;QACZ,2CAA2C;QAC3C,2BAA2B;QAC3B,gBAAgB;QAChB,uBAAuB;QACvB,aAAa;QACb,iBAAiB;QACjB,kBAAkB;EACxB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,cAAc;QACV,iBAAiB;EACvB;AACF;;AAEA,sDAAsD;AACtD,sBAAsB;AACtB,sDAAsD;;;;AAItD;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;IACT,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;MACM,cAAc;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;MACM,kBAAkB;IACpB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* ================================================= */\n/* BASE LAYOUT */\n/* ================================================= */\n\n.final-step {\n  max-width: 800px;\n  margin: 15px auto;\n  padding: 2px;\n}\n\n.final-step-header {\n         font-size: 24px;\n    margin-left: 22px;\n}\n\n.final-step-prequal {\n  font-size: 16px;\n  color: #555;\n  margin-bottom: 20px;\n  padding: 0 10px 0 22px;\n}\n.final-step-button {\n  background-color: #4CAF50;\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.ai-benefits {\n  text-align: left;\n  font-size: 15px;\n  color: #555;\n  margin-bottom: 10px;\n  padding: 0 10px 0 12px;\n  margin-top: 1px;\n  margin-left: 11px;\n}\n\nh2 {\n  text-align: left;\n  font-size: 20px;\n  margin: 10px 0;\n}\n\np {\n \n  font-size: 15px;\n  margin: 10px 0;\n}\n\n/* ================================================= */\n/* TEXT WRAPPING */\n/* ================================================= */\n\n.report-output,\n.report-p,\n.report-li {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  white-space: normal;\n}\n\n/* ================================================= */\n/* TYPOGRAPHY */\n/* ================================================= */\n\n.report-h2 {\n  margin-top: 20px;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.report-h3 {\n  margin-top: 16px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.report-p {\n  margin-bottom: 10px;\n  line-height: 1.6;\n}\n\n.report-ul {\n  margin: 8px 0 16px 18px;\n  padding-left: 12px;\n}\n\n.report-li {\n  margin-bottom: 6px;\n}\n\n/* ================================================= */\n/* IMAGE GALLERY */\n/* ================================================= */\n\n.image-gallery {\n  display: flex;\n  gap: 12px;\n  margin: 16px 0;\n  flex-wrap: wrap;\n}\n\n.report-image {\n  max-width: 180px;\n  border-radius: 6px;\n  object-fit: cover;\n}\n\n/* ================================================= */\n/* REPORT PANEL */\n/* ================================================= */\n\n.report-panel {\n  display: flex;\n  flex-direction: column;\n}\n\n.report-output {\n  padding: 15px;\n  padding-top: 1px;\n  background: #fafafa;\n  border-radius: 8px;\n}\n\n/* ================================================= */\n/* CARET ANIMATION */\n/* ================================================= */\n\n.caret {\n  animation: blink 1s steps(1) infinite;\n}\n\n@keyframes blink {\n  50% { opacity: 0; }\n}\n\n/* ================================================= */\n/* IMAGE STRIP */\n/* ================================================= */\n\n.report-image-strip {\n  display: flex;\n  gap: 12px;\n  margin: 24px auto 32px;\n  width: 50%;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.report-image-strip img {\n  max-width: calc(33.333% - 8px);\n  height: auto;\n  border-radius: 8px;\n  object-fit: cover;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\nhtml[data-brand=\"house-helper\"] .featured-widget {\n  border-color: rgba(124, 194, 67, 0.5);\n}\n\n\n/* ================================================= */\n/* TWO COLUMN LAYOUT */\n/* ================================================= */\n\n/* -------- Desktop + Tablet -------- */\n@media (min-width: 550px) {\n\n  .featured-widget {\n    background: #ffffff;\n    border-radius: 16px;\n    padding: 10px;\n    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);\n    border: 1px solid #3690ffa2;\n    width: 200px;\n  }\n\n  .final-two-column {\n    display: flex;\n    gap: 12px;\n    align-items: flex-start;\n    margin-top: 20px;\n  }\n\n  .final-left {\n    flex: 0 0 74%;\n    margin-left: 15px;\n  }\n\n  .final-right {\n    flex: 0 0 20%;\n  }\n\n  .featured-widget {\n    position: sticky;\n    top: 120px;\n  }\n}\n\n/* -------- Mobile Only -------- */\n@media (max-width: 550px) {\n\n\n  .final-two-column {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .final-left,\n  .final-right {\n    width: 100%;\n  }\n\n  .featured-widget {\n     position: relative;\n        top: auto;\n        background: #ffffff;\n        border-radius: 16px;\n        padding: 7px;\n        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);\n        border: 1px solid #3690ffa2;\n        /* width: 95%; */\n        justify-content: center;\n        display: grid;\n        margin-left: 49px;\n        margin-right: 64px;\n  }\n\n  html[data-brand=\"house-helper\"] .featured-widget {\n    border-color: rgba(124, 194, 67, 0.5);\n  }\n\n  h2 {\n    text-align: center;\n  }\n\n  .report-output,\n  .report-p,\n  .report-li {\n    max-width: 94%;\n        margin-left: 10px;\n  }\n}\n\n/* ================================================= */\n/* RIGHT SIDE WIDGET */\n/* ================================================= */\n\n\n\n.featured-widget h3 {\n  margin-top: 0;\n  margin-bottom: 1px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.featured-widget-pro {\n  margin: 0px 0 10px;\n    padding: 6px 8px;\n    border: 1px solid rgba(54, 144, 255, 0.28);\n    border-radius: 12px;\n    background: #f7fbff;\n}\n\n.featured-widget-pro-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.featured-widget-pro-heading {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.featured-widget-pro-logo {\n  width: 55px;\n    height: 55px;\n    flex: 0 0 auto;\n    border-radius: 10px;\n    border: 1px solid rgba(23, 50, 78, 0.08);\n    object-fit: contain;\n    background: #ffffff;\n    padding: 2px;\n}\n\n.featured-widget-pro-label,\n.featured-widget-pro-name {\n  margin: 0;\n}\n\n.featured-widget-pro-label {\n  color: #1d77bd;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n.featured-widget-pro-name {\n  color: #17324e;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.featured-widget-pro-link {\n      color: #1d77bd;\n    font-size: 12px;\n    font-weight: 700;\n    text-decoration: none;\n    justify-self: center;\n    text-align: center;\n    width: 100%;\n    display: block;\n}\n\n.featured-widget-pro-link:hover {\n  text-decoration: underline;\n}\n\n.widget-button {\n      margin-bottom: 5px;\n    background-color: #0d6efd;\n    color: #ffffff;\n    padding: 6px 11px;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    width: 100%;\n    font-weight: 600;\n    font-size: 10pt !important;\n}\n\n.widget-button:hover {\n  background-color: #0b5ed7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
